import headerRouter from './components/CasHeader/headerRouter';
import sideRouter from './components/Sider/sideRouter';
import { PermissionNameEnum } from '@Types/permissions';
import policyRouter from './pages/Policy/policyRouter';
import reportRouter from './pages/Report/reportRouter';
import administratorRouter from './pages/Administrator/administratorRouter';
import quarantineRouter from './pages/Quarantine/quarantineRouter';

export interface Router {
  path: string;
  name: string;
  element: any;
  permission?: PermissionNameEnum | PermissionNameEnum[];
  show?: boolean;
  childRoutes?: Router[];
}
const routerConfig: Router[] = [
  ...sideRouter,
  ...headerRouter,
  ...reportRouter,
  ...policyRouter,
  ...administratorRouter,
  ...quarantineRouter,
];
export default routerConfig;
